export default {
    loading: false,
    error: null,
    accessToken: null,
    user: {}
};
